// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7493 ? "bf5f3635" : chunkId) + "." + {"7289":"09d62dacc64c6c67","7493":"2ff027075a05d3ee"}[chunkId] + ".js";
};